import React, { useEffect, useState } from "react";
import { LockKeyhole, LogIn, Mail } from "lucide-react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminLogin() {
  const { login, isAuthenticated, loading } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { document.title = "Admin Login | St. Xavier's Bela"; }, []);
  if (!loading && isAuthenticated) return <Navigate to="/admin" replace />;

  async function handleSubmit(event) {
    event.preventDefault(); setSubmitting(true); setError("");
    try {
      await login({ email: email.trim(), password });
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) { setError(err.message); }
    finally { setSubmitting(false); }
  }

  return (
    <div className="admin-login-page">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <img src="/logo.png" alt="St. Xavier's Public School" />
        <small>ST. XAVIER'S PUBLIC SCHOOL BELA</small>
        <h1>Admin Login</h1>
        <p>Sign in to manage website content.</p>
        {error && <div className="admin-alert error">{error}</div>}
        <label><span>Email</span><div className="admin-input-icon"><Mail size={17} /><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div></label>
        <label><span>Password</span><div className="admin-input-icon"><LockKeyhole size={17} /><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div></label>
        <button className="admin-primary admin-login-button" disabled={submitting}>{submitting ? "Signing in..." : <><LogIn size={17} /> Sign In</>}</button>
      </form>
    </div>
  );
}
